import {createBrowserHistory} from 'history';
export const dataURLtoFile = (dataUrl: string, filename: string) => {
  var arr = dataUrl.split(",");
  var mime = arr[0].match(/:(.*?);/)![1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const blobToFile = (theBlob: Blob, fileName: string): File => {
  var b: any = theBlob;
  b.lastModifiedDate = new Date();
  b.name = fileName;
  return theBlob as File;
};
export const history = createBrowserHistory();
